import ContactCard from './ContactCard.component';

export default ContactCard;
